import type { RouteRecordRaw } from "vue-router";
import HomePage from "./HomePage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
];

export default routes;
